import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import './EditUserPage.css';
import ListaAvistamentos from './ListaAvistamentos';

function EditUserPage(){
    const userData = useSelector(state => state.usersList.editingUser)
    const date = new Date(userData.joined)
    const [observacoes, setObservacoes] = useState(0)

    useEffect(() => {
        

        
        setObservacoes(userData.n_animais + userData.n_ninhos + userData.n_ataques)
        
    }, []);
    
    return(
        <div className='page-body'>
            <div
                className='user-info' 
            >
                
                    <img
                        className='user-image'
                        src={`/app/avatars/avatar${userData.avatar}.png`}
                        
                    />
                    <div className='user-info-text'>
                        <div >
                            {userData.email}
                        </div>
                        <div >
                            {userData.username}
                        </div>
                        <div >
                            {date.toLocaleDateString("pt-PT")} {date.toLocaleTimeString("pt-PT", {hour:'2-digit', minute:'2-digit'})}
                        </div>
                        <div >
                            {userData.role}
                        </div>
                        <div style={{fontWeight:'bold'}}>Observações:</div>
                        <div >
                            {userData.n_animais} gaivotas
                        </div>
                        <div >
                            {userData.n_ninhos} ninhos
                        </div>
                        <div >
                            {userData.n_ataques} ataques
                        </div>


                        
                        
                        
                       
                        
                        
                    </div>
                
                    
            </div>
         
                <ListaAvistamentos tipo = 'administrador' n_obs={observacoes}/>   
                    
  
        </div>
    )
   
    
    

    
}

export default EditUserPage;